// Where ActionCable may subscribe (limits /cable WebSocket to these URLs only).

export function isPrincipalListingHomeCablePage() {
  if (typeof window === "undefined" || !window.location) return false
  const p = window.location.pathname || ""
  return p === "/" || p === ""
}

// Public auction ad page, e.g. /online-auction/helsinki/my-ad-title/123784
export function isAuctionDetailCablePage() {
  if (typeof window === "undefined" || !window.location) return false
  const p = window.location.pathname || ""
  return /^\/online-auction\/[^/]+\/[^/]+\/\d+$/.test(p)
}

export function isAdminOffersMultiAuctionCablePage() {
  if (typeof window === "undefined" || !window.location) return false
  const p = window.location.pathname || ""
  return p === "/admin/offers/open_active_bids" || p === "/admin/offers/check_own_wishlist"
}
